/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期时间"
          default-time="12:00:00">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="orderStatus" placeholder="请选择订单类型">
          <el-option v-for="type in payway" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="orderList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="orderNum" label="订单号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="payMethod" label="支付方式" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="totalNum" label="商品数量" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="subtract" label="利润" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="price" label="支付金额" width="180" show-overflow-tooltip >
      </el-table-column>
      <el-table-column  prop="content" label="商品名称" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="orderStatus" label="订单状态" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="updateTime" label="创建时间" width="180" show-overflow-tooltip align="center">

      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
        <el-form label-width="120px" :model="editForm" ref="editForm">
          <el-row>
            <el-col :span="20">
              <el-form-item label="订单号">
                <el-input size="small" v-model="editForm.orderNum" auto-complete="off" placeholder="订单号" disabled></el-input>
              </el-form-item>
              <el-form-item label="时间">
                <el-input size="small" v-model="editForm.createTime" auto-complete="off" placeholder="订单号" disabled></el-input>
              </el-form-item>
              <el-form-item label="支付方式">
                <el-input size="small" v-model="editForm.payMethod" auto-complete="off" placeholder="请输入商户号" disabled></el-input>
              </el-form-item>
              <el-form-item label="利润">
                <el-input size="small" v-model="editForm.subtract" auto-complete="off" placeholder="请输入微信子商户" disabled></el-input>
              </el-form-item>
              <el-form-item label="支付金额">
                <el-input size="small" v-model="editForm.price" auto-complete="off" placeholder="请输入通知回调" disabled></el-input>
              </el-form-item>
              <el-form-item label="会员优惠">
                <el-input size="small" v-model="editForm.vipYouHuiPrice" auto-complete="off" placeholder="请输入加密类型" disabled></el-input>
              </el-form-item>
              <el-form-item label="活动优惠">
                <el-input size="small" v-model="editForm.activityYouHuiPrice" auto-complete="off" placeholder="请输入商户签名密钥" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="购买商品">
            <el-input size="small" v-model="editForm.newContent" auto-complete="off" placeholder="购买的商品" disabled  style="white-space: pre-line;"></el-input>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from '../../api/payMG'
import Pagination from '../../components/Pagination'

import {getOrder} from '@/api/api.js'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      date:'',
      year:'',
      month:'',
      day:'',
      orderStatus:'',//订单类型
      payway: [
        { key: '全部订单', value: 0 },
        { key: '已完成订单', value: 1 },
        { key: '已取消订单', value: 2 },
        { key: '已退款订单', value: 3 },
      ],
      orderList:[],//订单列表
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    this.getData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    // getdata(parameter) {
    //   this.loading = true
    //   // 模拟数据开始
    //   let res = {
    //     code: 0,
    //     msg: null,
    //     count: 23,
    //     data: [
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526380193000,
    //         editTime: 1526380193000,
    //         orderId: 109,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: 'xxxx',
    //         transId: 'xxxx',
    //         payType: 6,
    //         subPayType: 'WXPay',
    //         transType: '退款',
    //         machineNo: '111111',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: -0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 14,
    //         openId: null,
    //         mchId: '111111111111111',
    //         subMchId: null,
    //         remark: '不允许从此IP发起交易: 101.81.251.226'
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526380176000,
    //         editTime: 1526380176000,
    //         orderId: 108,
    //         deptId: 1,
    //         deptName: 'xxxxxx',
    //         orderNo: 'xxxx',
    //         transId: 'xxxxx',
    //         payType: 6,
    //         subPayType: 'WXPay',
    //         transType: '退款',
    //         machineNo: 'J1AX904002',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: -0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 14,
    //         openId: null,
    //         mchId: '898310154990338',
    //         subMchId: null,
    //         remark: '不允许从此IP发起交易: 101.81.251.226'
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1524921444000,
    //         editTime: 1524894094000,
    //         orderId: 107,
    //         deptId: 1,
    //         deptName: 'xxxxxx',
    //         orderNo: 'J1AX90400220180428101723945',
    //         transId: '4200000137201804287543647891',
    //         payType: 6,
    //         subPayType: 'WXPay',
    //         transType: '消费',
    //         machineNo: 'J1AX904002',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 7,
    //         openId: null,
    //         mchId: '898310154990338',
    //         subMchId: null,
    //         remark: '无法找到指定的账单'
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521307596000,
    //         editTime: 1524641207000,
    //         orderId: 20,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: '9300079120180318142634440',
    //         transId: null,
    //         payType: 0,
    //         subPayType: '0',
    //         transType: '消费',
    //         machineNo: '111111111111111',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 7,
    //         openId: null,
    //         mchId: null,
    //         subMchId: null,
    //         remark: '1111111111111111111111'
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1520195909000,
    //         editTime: 1520195909000,
    //         orderId: 19,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: '9300079120180305183828606',
    //         transId: null,
    //         payType: 0,
    //         subPayType: '0',
    //         transType: '消费',
    //         machineNo: '93000791',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 1,
    //         openId: null,
    //         mchId: null,
    //         subMchId: null,
    //         remark: null
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1520035180000,
    //         editTime: 1520035180000,
    //         orderId: 18,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: '4200000056201803031934477774',
    //         transId: '9300079120180303170851281',
    //         payType: 6,
    //         subPayType: 'WXPay',
    //         transType: '退款',
    //         machineNo: '222222222222222222',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 8,
    //         openId: null,
    //         mchId: '898310154990338',
    //         subMchId: null,
    //         remark: null
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1520020261000,
    //         editTime: 1520185478000,
    //         orderId: 17,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: '9300079120180303175059985',
    //         transId: '4200000072201803031887274444',
    //         payType: 6,
    //         subPayType: 'WXPay',
    //         transType: '消费',
    //         machineNo: '93000791',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 7,
    //         openId: null,
    //         mchId: '898310154990338',
    //         subMchId: null,
    //         remark: '不允许从此IP发起交易: 116.247.119.165'
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1520019911000,
    //         editTime: 1520020075000,
    //         orderId: 16,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: '9300079120180303174511778',
    //         transId: '4200000055201803031949877221',
    //         payType: 6,
    //         subPayType: 'WXPay',
    //         transType: '消费',
    //         machineNo: '93000791',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 1,
    //         openId: null,
    //         mchId: '898310154990338',
    //         subMchId: null,
    //         remark: null
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1520019776000,
    //         editTime: 1520019776000,
    //         orderId: 15,
    //         deptId: 1,
    //         deptName: 'xxxx',
    //         orderNo: '9300079120180303174256156',
    //         transId: null,
    //         payType: 0,
    //         subPayType: '0',
    //         transType: '消费',
    //         machineNo: '93000791',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 1,
    //         openId: null,
    //         mchId: null,
    //         subMchId: null,
    //         remark: null
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1520019729000,
    //         editTime: 1520019729000,
    //         orderId: 14,
    //         deptId: 1,
    //         deptName: '上海XX',
    //         orderNo: '9300079120180303174208429',
    //         transId: null,
    //         payType: 0,
    //         subPayType: '0',
    //         transType: '消费',
    //         machineNo: '93000791',
    //         goodsNo: '123456',
    //         goodsPrice: 0.01,
    //         payAmount: 0.01,
    //         goodsName: '可乐',
    //         aisleNo: null,
    //         orderStatus: 1,
    //         openId: null,
    //         mchId: null,
    //         subMchId: null,
    //         remark: null
    //       }
    //     ]
    //   }
    //   this.loading = false
    //   this.listData = res.data
    //   this.pageparm.currentPage = this.formInline.page
    //   this.pageparm.pageSize = this.formInline.limit
    //   this.pageparm.total = res.count
    //   // 模拟数据结束

    //   /***
    //    * 调用接口，注释上面模拟数据 取消下面注释
    //    */

    //   // OrderList(parameter)
    //   //   .then(res => {
    //   //     this.loading = false
    //   //     if (res.success == false) {
    //   //       this.$message({
    //   //         type: 'info',
    //   //         message: res.msg
    //   //       })
    //   //     } else {
    //   //       this.listData = res.data
    //   //       // 分页赋值
    //   //       this.pageparm.currentPage = this.formInline.page
    //   //       this.pageparm.pageSize = this.formInline.limit
    //   //       this.pageparm.total = res.count
    //   //     }
    //   //   })
    //   //   .catch(err => {
    //   //     this.loading = false
    //   //     this.$message.error('菜单加载失败，请稍后再试！')
    //   //   })
    // },

    // 获取订单数据
    getData(){
      this.loading = true
      //转化日期的格式
      const selectedDate = new Date(this.date);
      this.year = selectedDate.getFullYear();
      this.month = selectedDate.getMonth() + 1; // 月份从0开始，所以要加1
      this.day = selectedDate.getDate();
      getOrder({
        year:this.year,
        month:this.month,
        day:this.day,
        pageNum: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        storeId:localStorage.getItem('storeId'),
        orderStatus: this.orderStatus
      }).then((res)=>{
        //改变数组里元素的某个属性
        res.data.records.forEach((item)=>{
          item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
          item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
          item.newContent = item.content.replace(/\\n/g, '<br>')
        })
        this.orderList = res.data.records
        this.loading = false
        this.pageparm.currentPage = this.formInline.page
        
        this.pageparm.pageSize = this.formInline.limit
        
        this.pageparm.total = res.data.total

      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.pageparm.currentPage = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.pageparm.pageSize =  parm.pageSize
      // this.getdata(this.formInline)
      this.getData()
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      console.log(index,row,'333333')
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue